module.exports = __webpack_public_path__ + "static/media/punto-GO.dacfe184.png";